<template>
<div>
    <b-modal ref="modal" title="Carta de Correção NF-e" header-class="border-bottom-0" size="lg"  no-close-on-backdrop>
        
               <div class="row">
            <div class="col-md-12">
                <h5 class="text-primary">
                    <i class="fas fa-envelope" /> Carta de Correção Nota Fiscal Nº #{{this.number}}
                </h5>
            </div>
        </div>
        <br />

        <div class="row">
            <div class="col-md-12">
                <div class="form-group">
                    <textarea maxlength="500" class="form-control" id="exampleFormControlTextarea1" rows="5" v-model="form.xJust.value" placeholder="Erro de digitação dos Produtos"></textarea>
                </div>
            </div>
        </div>
        <div slot="modal-footer">
            <button role="button" class="btn btn-outline-secondary" @click="$refs.modal.hide()">
                <i class="fas fa-times"></i> Voltar
            </button>
            <button role="button" class="btn btn-danger" style="margin-left:5px" @click="correctLetterNfeSefaz">
                <i class="fas fa-check"></i> Enviar Correção NF
            </button>
        </div>
        <error-handler :error="error" />
        <b-alert :show="alertData.isVisible" fade variant="danger" @dismissed="alertData.isVisible = false" dismissible>{{ alertData.message }}</b-alert>
    </b-modal>
</div>
</template>

<script>
import Form from "./../../../mixins/Form";

export default {
    data: function () {
        return {
            form: new Form({

                xJust: {},
            }),

            number: {},

            error: null,

            alertData: {
                isVisible: false,
                message: null
            },
        };
    },

    methods: {
        open(id = null, nNF) {

            this.$refs.modal.show();

            this.nfeId = id;

            this.number = nNF

        },

        correctLetterNfeSefaz(nfeId) {
            this.$store.commit("showLoading");

            axios.post("api/nfe/correctletter/" + this.nfeId, this.form.getValues())
                .then(response => {
                    this.$store.commit("hideLoading");
                    this.$emit("stored");
                })
                .catch(error => {
                    this.$store.commit("hideLoading");
                    this.error = error;
                });
        },

        resetForm() {
            this.error = null;

            this.alertData.isVisible = false;

            this.form.reset();
        }
    }
};
</script>

<style>
</style>
